import { ReactNode, useEffect } from "react";
import ReactDOM from "react-dom";
import styled from "styled-components/macro";
import { THEME_COLOR_DARK } from "../vars";
import { useSkipioApi, isImpersonating } from "../api";
import { useQuery } from "@tanstack/react-query";
import { fetchUser } from "../api/users";

function ImpersonationBanner() {
  const skipioApi = useSkipioApi();
  const user = useQuery({
    queryKey: ["users", "me"],
    queryFn: fetchUser,
    select: (queryData) => queryData.data,
  }).data!;

  const impersonating = !user.isTrueUser && !isImpersonating();

  useEffect(() => {
    if (!impersonating) return;
    document.body.style.backgroundColor = THEME_COLOR_DARK;
  }, [impersonating]);

  if (!impersonating) return null;

  async function unImpersonate() {
    const {
      data: { redirectUrl },
    } = await skipioApi.impersonation.delete();
    window.location.href = redirectUrl;
  }

  return ReactDOM.createPortal(
    <BlueImpersonatingBox>
      You are impersonating {user.firstName} {user.lastName}{" "}
      <LinkButton onClick={unImpersonate}>Exit View</LinkButton>
    </BlueImpersonatingBox>,
    document.body
  );
}

export default function Main({ children }: { children: ReactNode }) {
  return (
    <Container>
      <ImpersonationBanner />
      {children}
    </Container>
  );
}

const Container = styled.div`
  display: grid;
  grid-template-areas:
    "notification notification"
    "nav          content";
  grid-template-columns: 65px auto;
  grid-template-rows: auto minmax(0, 1fr);
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
`;

const BlueImpersonatingBox = styled.div`
  position: absolute;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);
  background: ${THEME_COLOR_DARK};
  border-top-left-radius: 7px;
  border-top-right-radius: 7px;
  padding: 5px 20px;
  color: white;
  z-index: 2000;
  a {
    color: white;
    text-decoration: underline;
  }
`;

const LinkButton = styled.a`
  color: white;
  text-decoration: underline;
  cursor: pointer;
`;
